import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Cars from "./pages/Cars";
import Contact from "./pages/Contact";
import CarDetails from "./pages/CarDetails";
import Booking from "./pages/Booking";

import PageTransition from "./components/PageTransition";
import Loader from "./components/Loader";

function App() {
  return (
    <Router>
      <Loader />

      <Navbar />

      <PageTransition>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/about" element={<About />} />

          <Route path="/cars" element={<Cars />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/car/:id" element={<CarDetails />} />

          <Route path="/booking" element={<Booking />} />
        </Routes>
      </PageTransition>

      <Footer />
    </Router>
  );
}

export default App;
